import React, { useEffect, useState } from 'react'
import CustomInput from '../../../components/CustomInputs/CustomInput'
import CustomSelectInput from '../../../components/CustomSelectInput/CustomSelectInput'
import { Button } from 'flowbite-react'
import { FaEye, FaPlusCircle } from 'react-icons/fa'
import icon from '../../../assets/shareholdersIcon.png'
import client from '../../../api/client'

const CreateInvoiceModalContent = () => {
    const [formData, setFormData] = useState({
        invoiceTitle: "",
        currencyId: "",
        dueDate: "",
        quantity: 0,
        amount: 0,
        item: "",
        price: 0,
        totalAmount: 0,
        discount: 0,
        tax: 0,
        description: "",
        companyName: "",
        customerEmail: "",
        customerName: "",
        companyEmail: "",
        logo: ""
    })
    const [step, setStep] = useState(1)
    const [currencies, setCurrencies] = useState([])
    const [invoiceItems, setInvoiceItems] = useState<any[]>([])

    useEffect(() => {
        const fetchData = async () => {
            await fetchCurrencies()
        }
        fetchData()
    }, [])

    useEffect(() => {
        // Calculate total amount whenever quantity, price, tax, or discount changes
        const calculateTotalAmount = () => {
            const total = formData.quantity * formData.price;
            const taxAmount = (formData.tax / 100) * total;
            const totalWithTaxAndDiscount = total + taxAmount - formData.discount;
            setFormData(prevFormData => ({
                ...prevFormData,
                totalAmount: totalWithTaxAndDiscount
            }));
        };

        calculateTotalAmount();
    }, [formData.quantity, formData.price, formData.tax, formData.discount]);

    const fetchCurrencies = async () => {
        try {
            const response = await client.get("/subsidiary/dashboard/service/currencies");
            if (response.data.status === "success") {
                setCurrencies(response.data.data);
            } else {
                console.log(response.data.message);
            }
        } catch (err) {
            console.error('error getting countries', err);
        }
    }
    const changeStep = (level: number) => {
        setStep(level)
    }

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const addNewItem = (item: any) => {
        setInvoiceItems(prevInvoiceItems => [...prevInvoiceItems, item]);

    };
    const createInvoice = async () => {
        let payload = {
            invoiceTitle: formData.invoiceTitle,
            currencyId: formData.currencyId,
            dueDate: formData.dueDate,
            invoiceItems: invoiceItems,
            amount: formData.totalAmount,
            discount: formData.discount,
            tax: formData.tax,
            description: formData.description,
            businessDetails: {
                companyName: formData.companyName,
                customerName: formData.customerName,
                emailAddress: formData.customerEmail,
                companyEmailAddress: formData.companyEmail,
                logo: formData.logo
            }
        }

    }
    return (
        <div className=''>
            {step == 1 && (
                <>
                    <div>
                        <img src={icon} className='my-3' />
                        <div className='my-3'>
                            <p className='text-xl font-bold'>Business Details</p>
                            <p className='text-sm'>Kindly fill in information needed</p>
                        </div>
                    </div>
                    <CustomInput label='Invoice Title' value={formData.invoiceTitle} onChange={handleInputChange} name='invoiceTitle' />
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4 my-2'>
                        <CustomInput name='amount' label='Amount' value={formData.amount} onChange={handleInputChange} />
                        <CustomSelectInput label='Currency' name='currency' onChange={(value) => setFormData({ ...formData, currencyId: value })} items={currencies} displayKey='shortName' valueKey='id' />
                    </div>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4 my-2'>
                        <CustomInput name='customerName' label="Customer's Name " value={formData.customerName} onChange={handleInputChange} />
                        <CustomInput name='companyName' label="Company Name" value={formData.companyName} onChange={handleInputChange} />

                    </div>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4 my-2'>
                        <CustomInput name='customerEmail' label="Customer Email" value={formData.customerEmail} onChange={handleInputChange} />
                        <CustomInput name='companyEmail' label="Company Email" value={formData.companyEmail} onChange={handleInputChange} />

                    </div>
                    <div className='flex gap-3 my-2'>
                        <Button className='w-full md:w-1/4 ring-gray-400' outline>Cancel</Button>
                        <Button className='w-full md:w-3/4 bg-custom-button-green' onClick={() => changeStep(2)}>Go to Invoice</Button>

                    </div>
                </>
            )}
            {step == 2 && (
                <div>
                    <div className='bg-green-50 h-48 p-4'>
                        <div className='flex justify-between'>
                            <div>
                                <p className='text-xl font-bold'>Invoice</p>
                            </div>
                            <div>
                                <p className='text-sm'>Invoice No</p>
                                <p className='font-semibold'>#0000123</p>
                            </div>
                        </div>
                        <div className='flex justify-between'>
                            <div>
                                <p className='text-sm'>Billed To</p>
                                <p className='font-semibold'>{formData.customerName}</p>
                                <p className='text-sm'>{formData.customerEmail}</p>
                            </div>
                            <div className='mt-20'>
                                <p className='text-sm text-right'>Issued on</p>
                                <p className='font-semibold'>{new Date().toLocaleDateString()}</p>
                            </div>
                        </div>

                    </div>
                    <div className='mt-6'>
                        <div className='grid grid-cols-1 md:grid-cols-2 gap-8 items-center'>

                            <div>
                                <p className='font-bold'>Services</p>
                                <CustomInput label='' name='item' />
                            </div>
                            <div className='flex gap-4'>
                                <div className='text-center'>
                                    <p className='text-sm'>Qty.</p>
                                    <CustomInput label='' name='quantity' value={formData.quantity} onChange={handleInputChange} className='w-16' />
                                </div>
                                <div className='text-center'>
                                    <p className='text-sm'>Price</p>
                                    <CustomInput label='' name='price' value={formData.price} onChange={handleInputChange} />
                                </div>
                                <div className='text-center'>
                                    <p className='text-sm'>Total</p>
                                    <CustomInput label='' name='totalAmount' value={formData.totalAmount} />
                                </div>
                            </div>

                        </div>
                        <div className='flex gap-3 items-center text-green-500' onClick={() => addNewItem({ item: formData.item, amount: formData.price, quantity: formData.quantity })}>
                            <FaPlusCircle />
                            Add New
                        </div>
                        {invoiceItems && (
                        <div className='grid grid-cols-2'>
                            <div>
                                <p className='text-sm font-bold'>Services</p>
                            </div>
                            <div className='flex gap-20 justify-end'>
                                <div>
                                    <p className='text-sm text-center font-thin'>Qty.</p>
                                </div>
                                <div>
                                    <p className='text-sm text-center font-thin'>Price</p>
                                </div>
                                <div>
                                    <p className='text-sm text-center font-thin'>Total</p>
                                </div>
                            </div>
        {invoiceItems.map((item, index) => (
            <React.Fragment key={index}>
                <div>
                    {item.item}
                </div>
                <div>
                    <p className='text-sm flex justify-center'>{item.quantity}</p>
                </div>
                <div>
                    <p className='text-sm flex justify-center'>{item.price}</p>
                </div>
                <div>
                    <p className='text-sm flex justify-center'>{item.quantity * item.price}</p>
                </div>
            </React.Fragment>
        ))}
    </div>
)}


                        <div className='relative grid grid-cols-1 md:grid-cols-2 h-80'>
                            <div className="absolute bottom-0 right-0 flex justify-end">
                                <div className='flex flex-col gap-4'>
                                    <div className='flex gap-2 justify-end'>
                                        <p className='text-sm mt-2'>Tax</p>
                                        <CustomInput name='tax' label='' value={formData.tax} onChange={handleInputChange} />
                                    </div>
                                    <div className='flex gap-2 justify-end'>
                                        <p className='text-sm mt-2'>Discount</p>
                                        <CustomInput name='discount' label='' value={formData.discount} onChange={handleInputChange} />
                                    </div>
                                    <div className='bg-green-50 justify-end p-4 rounded-lg w-full'>
                                        <div className='flex gap-20'>
                                            <p>Total (USD) </p>
                                            <span className='font-semibold'>{formData.totalAmount}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='grid grid-cols-1 md:grid-cols-2 items-center my-6'>
                            <div>
                                <img src='' className='w-12 h-12' />
                                <p className='text-sm font-bold'>Tadainc Company</p>
                                <p className='text-sm'>Address</p>
                            </div>
                            <div>
                                <CustomInput label='Additional Notes' name='note' />
                            </div>
                        </div>

                        <div className='flex gap-2 my-6'>
                            <Button className='w-1/4 ring-gray-200' outline>Cancel</Button>
                            <Button className='bg-transparent text-black w-1/4' onClick={() => changeStep(3)}>
                                <div className='flex items-center gap-2'>
                                    <FaEye />
                                    Preview
                                </div>
                            </Button>
                            <Button className='w-2/4 bg-custom-button-green text-black'>
                                Send Invoice
                            </Button>
                        </div>
                    </div>

                </div>

            )}
            {step === 3 && (
                <div>
                    <div className='bg-green-50 h-48 p-4'>
                        <div className='flex justify-between'>
                            <div>
                                <p className='text-xl font-bold'>Invoice</p>
                            </div>
                            <div>
                                <p className='text-sm'>Invoice No</p>
                                <p className='font-semibold'>#0000123</p>
                            </div>
                        </div>
                        <div className='flex justify-between'>
                            <div>
                                <p className='text-sm'>Billed To</p>
                                <p className='font-semibold'>{formData.customerName}</p>
                                <p className='text-sm'>{formData.customerEmail}</p>
                            </div>
                            <div className='mt-20'>
                                <p className='text-sm text-right'>Issued on</p>
                                <p className='font-semibold'>{new Date().toLocaleDateString()}</p>
                            </div>
                        </div>

                    </div>
                    <div className='mt-6'>
                        <div className='grid grid-cols-2'>
                            <div>
                                <p className='text-sm font-bold'>Services</p>
                                <p className='text-sm flex justify-text'>{formData.item}</p>
                            </div>
                            <div className='flex gap-20 justify-end'>
                                <div>
                                    <p className='text-sm text-center font-thin'>Qty.</p>
                                    <p>{formData.quantity}</p>
                                </div>
                                <div>
                                    <p className='text-sm text- font-thin'>Price</p>
                                    <p>{formData.price}</p>
                                </div>
                                <div>
                                    <p className='text-sm text-center font-thin'>Total</p>
                                    <p>{formData.totalAmount}</p>
                                </div>
                            </div>

                        </div>

                        <div className='relative grid grid-cols-1 md:grid-cols-2 h-80'>
                            <div></div>
                            <div className="absolute bottom-0 right-0">
                                <div className='flex flex-col gap-4'>
                                    <div className='flex items-center gap-2 justify-end'>
                                        <p className='text-sm font-thin'>Tax</p>
                                        <p className='text-sm font-medium'>{formData.tax}%</p>
                                    </div>
                                    <div className='flex items-center gap-2 justify-end'>
                                        <p className='text-sm font-thin'>Discount</p>
                                        <p className='text-sm font-medium'>{formData.discount}</p>
                                    </div>
                                    <div className='bg-green-50 justify-end p-4 rounded-lg w-full'>
                                        <div className='flex gap-20'>
                                            <p>Total (USD) </p>
                                            <span className='font-semibold'>{formData.totalAmount}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='grid grid-cols-1 md:grid-cols-2 items-center'>
                            <div>
                                <img src='' className='w-12 h-12' />
                                <p className='text-sm font-bold'>Tadainc Company</p>
                                <p className='text-sm'>Address</p>
                            </div>
                            <div className='flex flex-col items-center'>
                                <p className='text-sm font-semibold'>Additional notes</p>
                                <p className='text-sm font-thin'>Have a great day</p>
                            </div>
                        </div>

                        <div className='flex gap-2 my-6'>
                            <Button className='w-1/4 ring-gray-200' outline onClick={() => changeStep(2)}>Edit</Button>
                            <Button onClick={() => createInvoice()} className='w-3/4 bg-custom-button-green text-black text-xl font-bold'>
                                Send Invoice
                            </Button>
                        </div>
                    </div>

                </div>
            )}

        </div>

    )
}

export default CreateInvoiceModalContent
